import { copy } from "shared/assets";
import { DateChangeProps, IFieldType, IFormFields } from "shared/types";

const { userTravelVisa, errors } = copy;

export const getFormFields = ({
  handleIssueDateChange,
  handleExpiryDateChange,
  isIssueBeforeExpiry,
  isExpiryInFuture,
}: {
  handleIssueDateChange: (date: DateChangeProps) => void;
  handleExpiryDateChange: (date: DateChangeProps) => void;
  isIssueBeforeExpiry: boolean;
  isExpiryInFuture: boolean;
}): IFormFields => {
  return [
    {
      name: "title",
      label: userTravelVisa.fields.title,
      type: IFieldType.text,
    },
    {
      name: "documentType",
      label: userTravelVisa.fields.documentType.title,
      note: userTravelVisa.fields.documentType.note,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "issuingCountry",
      label: userTravelVisa.fields.issuingCountry,
      type: IFieldType.country,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "issuingAuthority",
      label: userTravelVisa.fields.issuingAuthority,
      type: IFieldType.text,
    },
    {
      name: "visaNumber",
      label: userTravelVisa.fields.visaNumber,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
    },
    {
      name: "passportNumber",
      label: userTravelVisa.fields.passportNumber.title,
      note: userTravelVisa.fields.passportNumber.note,
      validation: {
        required: errors.required,
      },
      type: IFieldType.text,
    },
    {
      name: "issueDate",
      label: userTravelVisa.fields.issueDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () => isIssueBeforeExpiry || userTravelVisa.messages.issueBeforeExpiry,
      },
      onChange: (value: string) => handleIssueDateChange({ date: value }),
    },
    {
      name: "expiryDate",
      label: userTravelVisa.fields.expiryDate,
      type: IFieldType.datePicker,
      validation: {
        required: errors.required,
        validate: () => isExpiryInFuture || userTravelVisa.messages.expiryInFuture,
      },
      onChange: (value: string) => handleExpiryDateChange({ date: value }),
    },
    {
      name: "files",
      label: userTravelVisa.fields.file,
      type: IFieldType.files,
      validation: {
        required: errors.required,
      },
      style: {
        gridColumn: "span 2",
      },
    },
    {
      name: "info",
      label: userTravelVisa.fields.info,
      type: IFieldType.rte,
      style: {
        gridColumn: "span 2",
      },
    },
  ];
};
